/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetApprovalRequestPathParams = NonNullable<operations['getApprovalRequest']['parameters']['path']>;

export type GetApprovalRequestQueryParams = NonNullable<operations['getApprovalRequest']['parameters']['query']>;

export interface Input extends GetApprovalRequestPathParams {
  apiVersion?: string;
  query?: GetApprovalRequestQueryParams;
}

export async function getApprovalRequest(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/approval-requests/{id}', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
